<!-- Premium App Layout with Enhanced Visual Hierarchy -->
<div class="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 font-raleway">
  <!-- Glass Header -->
  <app-header class="fixed top-0 left-0 right-0 "></app-header>

  <!-- Navigation Container (handles responsive nav) -->
  <app-navigation-container></app-navigation-container>

  <!-- Main Content Area with Premium Spacing -->
  <main
    class="pt-20 pl-[340px] lg:pl-[340px] md:pl-[300px] min-h-[calc(100vh-80px)] transition-[padding-left] duration-300 ease-[cubic-bezier(0.4,0,0.2,1)]"
    [class]="isMobile ? '!pl-0 !pb-[100px]' : ''"
    role="main"
    aria-label="Main content"
  >
    <!-- Content Container with Premium Styling -->
    <div class="min-h-full bg-gradient-to-b from-white to-gray-50/30">
      <div class="max-w-[1400px] mx-auto px-8 py-6 md:px-6 md:py-5 sm:px-4 sm:py-4">
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>

  <!-- Notification System -->
  <app-notification></app-notification>

  <!-- Premium Background Pattern (subtle) -->
  <div class="fixed inset-0 pointer-events-none z-[-1] opacity-[0.015]">
    <div class="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg%20width%3D%2260%22%20height%3D%2260%22%20viewBox%3D%220%200%2060%2060%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%3Cg%20fill%3D%22%23b55299%22%20fill-opacity%3D%221%22%3E%3Ccircle%20cx%3D%227%22%20cy%3D%227%22%20r%3D%221%22/%3E%3Ccircle%20cx%3D%2237%22%20cy%3D%2237%22%20r%3D%221%22/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')] bg-repeat"></div>
  </div>
</div>
